'use strict';

// import Swiper bundle with all modules installed
//import Swiper from "swiper/bundle";

function J3WTheme() {

    var self = this;

    self.$window = $(window);
    self.$document = $(document);
    self.$body = $("body");
    self.$header = $("#js-header");
    self.$hamburger = $(".hamburger");
    self.$mainMenu = $("#js-main-menu");
    self.$menu = $("#js-menu");

    self.scrollPos = ( document.body.getBoundingClientRect() ).top;
    self.scrollDirection = '';

    self.touchSupported = false;

    self.init();
}

J3WTheme.prototype = {

    init: function () {

        var self = this;

        //self.checkTouchEventsSupported();
        self.onBind();
        self.fancybox();
        self.calendar();
        //self.swiperHeroInit();
        //self.carouselInit();
/*
        self.$body.on("click", function() {

            var $iframe = $(this).find("#calendar_form3 iframe");

            if ( $iframe.length > 0 ) {

                var $head = $("#calendar_form3 iframe").contents().find("body");

                var css = '<style type="text/css">body { background: #000 !important; }</style>';

                console.log( $head );

                $head.append( css );
            }

        });
*/
    },

    onBind: function () {

        var self = this;

        // scrolling header
        /*
        self.headerHeight = self.$header.outerHeight();
        self.offset = 0;
        self.lastPos = 0;
        self.scrollTimer = new Date();

        if ( self.touchSupported === true ) {

            self.$body.on("touchend", function() {
                self.checkHeaderPosition();
                console.log("touchend");
            });
        }
        else {
            // Potrebujeme vedet, jestli se scrolluje nebo nebo
            // Cekame 300ms
            self.checkScrollTime();
        }
        */

        /*
        self.$window.on('scroll', function () {
            self.checkScrollDirection(self);
            self.scrollingHeader(self);
            //self.bodyScrollClass(self);
        });
        */

        self.$hamburger.on("click", function () {
            self.openMenu();
        });

        self.$document.keydown(function (e) {
            if (e.cancelable === true && e.key === 'Esc' || e.key === 'Escape' || e.keyCode === 27) {
                $("#js-searchbar").removeClass("searchbar--open");
            }
        });

        $(".more-info-btn").on("click", function(e) {
            $("#more-info").toggleClass("open");
            $(this).toggleClass("btn-icon--arr-expand btn-icon--arr-expand-less");
            e.preventDefault();
        });

    },

    checkTouchEventsSupported: function() {

        if ( 'ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch ) {
            self.touchSupported = true;
        }

    },

    calendar: function(){

        $(".js-calendar-accordion").on("click", function(e) {

            var $this = $(this).parent(),
                $more = $this.find(".js-calendar-more");

            if ( $this.hasClass("active") ) {
                $more.slideUp( 300 );
            }
            else {
                $more.slideDown( 300 );
            }

            $this.toggleClass("active");

            e.preventDefault();
        });

    },

    openMenu: function(){

        var self = this, t;

        clearTimeout( t );

        if ( self.$menu.hasClass("menu--open") ) {
            self.$menu.removeClass("menu--open");
            self.$body.removeClass("stop-scroll");
            t = setTimeout( function(){
                self.$hamburger.removeClass("is-active");
            }, 200 );
        }
        else {
            self.$body.addClass("stop-scroll");
            self.$menu.addClass("menu--open");
            t = setTimeout( function(){
                self.$hamburger.addClass("is-active");
            }, 200 );
        }

    },

    scrollingHeader: function( self ) {

        // https://jsfiddle.net/edwardomni/D58vx/4/

        self.scrollTimer = new Date();

        let newPos = self.$document.scrollTop(),
            pos = newPos - self.lastPos;

        if ( self.offset + pos > self.headerHeight ) {
            self.offset = self.headerHeight;
        } else if ( newPos < 0 ) { // webkit inertia scroll fix
            self.offset = 0;
        } else {
            self.offset = self.offset + pos;
        }

        if ( self.offset < 0 ) {
            self.offset = 0;
        }

        self.$header.css( 'top', ( -self.offset ) + 'px' );

        self.lastPos = newPos;

    },

    checkScrollTime: function() {

        let self = this;

        let now = new Date();

        // Co se ma dit po tom, co se prestane crollovat
        // V planu je, spustit to na mobilech az po touchend udalosti
        // Musi se to tosku prekopat
        if ( ( now.getTime() - self.scrollTimer.getTime() ) / 1000 > 0.3 ) {
            self.checkHeaderPosition();
        }

        setTimeout( function(){ self.checkScrollTime() }, 300 );
    },

    checkHeaderPosition: function() {

        let self = this;

        if ( self.$header.position().top !== 0 && self.$header.position().top !== -1 * self.headerHeight ) {
            if ( self.scrollDirection === 'down' ) {
                self.$header.css( 'top', 0 );
            }
            else {
                self.$header.css( 'top', -1 * self.headerHeight );
            }
        }

    },

    bodyScrollClass: function ( self ) {

        if ( self.scrollDirection === 'down' ) {
            self.$body.addClass('scroll-down');
        } else {
            self.$body.removeClass('scroll-down');
        }

    },

    checkScrollDirection: function( self ) {

        if ( ( document.body.getBoundingClientRect() ).top < self.scrollPos ) {
            self.scrollDirection = 'up';
        } else {
            self.scrollDirection = 'down';
        }

        self.scrollPos = ( document.body.getBoundingClientRect() ).top;

    },

    fancybox: function() {

        $('[data-fancybox="gallery"]').fancybox({
            loop: true,
            buttons: [
                "zoom",
                "share",
                "slideShow",
                "fullScreen",
                //"download",
                //"thumbs",
                "close"
            ]
        });
    },

    swiperHeroInit: function() {

        var self = this;

        self.swiperHero = new Swiper('#js-swiper-hero', {
            loop: true,
            speed: 900,
            autoplay: {
                delay: 5000,
                disableOnInteraction: true
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            keyboard: {
                enabled: true
            },
            preloadImages: false,
            lazyLoading: true,
            lazy: {
                loadPrevNext: true,
            },
            /*
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            pagination: {
                el: '.swiper-hero-pagination',
                type: 'bullets',
                clickable: true
            }*/
        });
    },

    carouselInit: function() {

        var self = this;

        self.swiperHero = new Swiper('#js-carousel', {
            loop: true,
            speed: 900,
            autoplay: {
                delay: 2000,
                disableOnInteraction: true
            },
            //effect: 'slide',
            fadeEffect: {
                crossFade: true
            },
            keyboard: {
                enabled: true
            },
            preloadImages: false,
            navigation: {
                nextEl: '.carousel-nav--next',
                prevEl: '.carousel-nav--prev'
            },
            on: {
                transitionEnd: function() {
                    // lazyLoadInstance defined in footer.php
                    lazyLoadInstance.update();
                }
            },
            /*
            pagination: {
                el: '.swiper-hero-pagination',
                type: 'bullets',
                clickable: true
            }*/
            slidesPerView: 1,
            spaceBetween: 10,
            breakpoints: {
                // when window width is >= 420px
                420: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                // when window width is >= 768px
                768: {
                    slidesPerView: 3,
                    spaceBetween: 20
                },
                // when window width is >= 1024px
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 40
                }
            }
        });
    }
};

$(document).ready(function () {
    new J3WTheme();
});
